module.exports = __webpack_public_path__ + "static/img/21-0623-detail3.c1239f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/21-0623-detail3.jpg
// module id = 23oY
// module chunks = 0